import { useTheme } from "@ugc-ui/lego";
import React, { ReactNode } from "react";
import { ModalContentWrapperStyled } from "@src/common/components/Modal/ModalTemplate/ModalContentWrapper/ModalContentWrapper.styled";

export interface IModalContentWrapper {
  className?: string;
  children?: ReactNode | ReactNode[];
  fullScreen?: boolean;
  dataCy?: string;
}

export const ModalContentWrapper: React.FC<IModalContentWrapper> = ({
  children,
  className,
  fullScreen,
  dataCy,
}) => {
  const theme = useTheme();

  return (
    <ModalContentWrapperStyled
      className={className}
      theme={theme}
      fullScreen={fullScreen}
      data-cy={dataCy}
    >
      {children}
    </ModalContentWrapperStyled>
  );
};
